/**
 * Cliente do better-auth (rotas /api/auth/* na mesma origem).
 * E-mail + senha (verificação obrigatória), magic link e reset de senha.
 */
import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { getLang } from "@/i18n";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:5173",
  basePath: "/api/auth",
  plugins: [magicLinkClient()],
  fetchOptions: {
    credentials: "include",
    // Resolve o fetch global a cada chamada (permite interceptação em testes com MSW).
    // e o idioma escolhido no painel vai junto (e-mails de verificação, link mágico e senha saem nesse idioma)
    customFetchImpl: (input, init) => {
      const headers = new Headers(init?.headers);
      headers.set("accept-language", getLang());
      return globalThis.fetch(input, { ...init, headers });
    },
  },
});

export type SessionData = typeof authClient.$Infer.Session;

/** URL absoluta no painel (callbacks dos e-mails). */
export const appUrl = (path: string) => `${window.location.origin}${path}`;
